import React, { createContext, useContext, useState, useEffect } from 'react';
import useLatestEpisodesQuery from '@mainHooks/query/useLatestEpisodesQuery.js';
import { ManualEpisodesModel } from '@models/ManualEpisodesModel.js';

export const Settings = createContext(null);

export const DataProvider = ({ children }) => {
    const state = useProviderSettings();
    return <Settings.Provider value={state}>{children}</Settings.Provider>;
};

const useProviderSettings = () => {
    const [dataSource, setDataSource] = useState(null);
    const { isLoading, model, error } = useLatestEpisodesQuery(dataSource);
    const [data, setData] = useState({
        episodes: [],
    });

    useEffect(() => {
        if (dataSource?.source === 'manual') {
            setData(new ManualEpisodesModel(dataSource).episodes);
        }
    }, [dataSource]);

    useEffect(() => {
        if (dataSource?.source === 'dynamic') {
            model.episodes && setData(model.episodes);
        }
    }, [isLoading, dataSource]);

    return {
        dataSource,
        setDataSource,
        data,
        isLoading,
        error,
    };
};

export const useDataContext = () => {
    const state = useContext(Settings);

    if (!state) {
        throw new Error('Error');
    }

    return state;
};
